export type Props = {
  readonly active?: boolean;
  readonly children: JSX.Element | JSX.Element[];
};

const TabsPanel = ({ active, children }: Props): JSX.Element => {
  return active === true ? <div>{children}</div> : null;
};

export default TabsPanel;
